import ComplaintRouter from './router';
// import { demoPageProps } from './demoprops';

function App({
  pageProps ,
  onPublish = (data) => console.log(data),
  onStepChange = (step) => console.log(step),
  

  children,
}) {
  console.log('App rolelist:', pageProps?.rolelist);
  return (
    <ComplaintRouter
      pageProps={pageProps}
      onPublish={onPublish}
      onStepChange={onStepChange}
     
    >
      {children}
    </ComplaintRouter>
  );
}

export default App;